export default "https://cdn-gra.amplement.io/statics/images/fallback-file-img.svg";